import { createContext, useContext } from 'react';

export const CompanyContext = createContext(null);

export function companyLevel4Name(company) {
  return typeof company?.level4 === 'string' && company.level4.trim()
    ? company.level4.trim()
    : 'Store';
}

/** Display labels only: never change field keys, option values, or API data. */
export function formatCompanyLabel(value, company) {
  const name = companyLevel4Name(company);
  return String(value ?? '').replace(/\bstores?\b/gi, () => name);
}

export function useCompanyLabels() {
  const company = useContext(CompanyContext);
  return {
    storeName: companyLevel4Name(company),
    label: (value) => formatCompanyLabel(value, company),
    fieldLabel: (field) => {
      const key = String(field.fieldKey ?? field.key ?? '').toLowerCase();
      if (key === 'storeid' || key === 'storeidcustom') return `${companyLevel4Name(company)} ID`;
      return formatCompanyLabel(field.fieldLabel ?? field.label ?? field.fieldName ?? '', company);
    },
  };
}
